import React from 'react';

import {ItemContainer} from 'features/categoryRefinements/components/category/item/container/container';
import {ItemImagePlaceholder} from 'features/categoryRefinements/components/category/item/imagePlaceholder/imagePlaceholder';
import {ItemTitle} from 'features/categoryRefinements/components/category/item/title/title';
import {ItemPrice} from 'features/categoryRefinements/components/category/item/price/price';

import s from './lensesPlaceholder.scss';

/**
 * Lenses Item Placeholder Component
 * @returns {React.NamedExoticComponent} rendered component
 */
export const LensesPlaceholder = React.memo(() => (
    <ItemContainer dataTestName="productPlaceholder">
        <div className={s.container}>
            <ItemImagePlaceholder />
            <div className={s.title}>
                <ItemTitle placeholder />
            </div>
            <div className={s.price}>
                <ItemPrice placeholder />
            </div>
        </div>
    </ItemContainer>
));

LensesPlaceholder.displayName = 'LensesPlaceholder';
